import DownloadIcon from '@mui/icons-material/Download';
import { IconButton, TableCell, TableRow, Tooltip, Typography } from '@mui/material';
import { REPORT_PACKAGE_ORDER, reportLabels } from '../../constants/reportLabels';
import type { Report } from '../../types';
import { formatBytes, formatReportDate } from '../../utils/reports';
import ReportPackageChips from './ReportPackageChips';

interface ReportHistoryRowProps {
  report: Report;
  isDownloading: boolean;
  onDownload: (report: Report) => void;
}

/** Server values (author, file name) are rendered as plain text nodes only. */
const ReportHistoryRow = ({ report, isDownloading, onDownload }: ReportHistoryRowProps) => {
  const created = formatReportDate(report.created_at);
  const downloadLabel = reportLabels.download_button(report.version);

  return (
    <TableRow hover>
      <TableCell component="th" scope="row">
        v{report.version}
      </TableCell>
      <TableCell>
        <Typography variant="body2">{created.local}</Typography>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
          {created.utc}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2" title={report.author.sub}>
          {report.author.display_name}
        </Typography>
      </TableCell>
      <TableCell>{formatBytes(report.size_bytes)}</TableCell>
      <TableCell sx={{ maxWidth: 180 }}>
        <Typography variant="body2" noWrap title={report.filename}>
          {report.filename}
        </Typography>
      </TableCell>
      <TableCell>
        <ReportPackageChips keys={REPORT_PACKAGE_ORDER} packages={report.packages} />
      </TableCell>
      <TableCell align="center">
        <Tooltip title={downloadLabel}>
          <IconButton aria-label={downloadLabel} onClick={() => onDownload(report)} loading={isDownloading}>
            <DownloadIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default ReportHistoryRow;
